import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/Button/Button';
import ButtonLabel from '../../../components/Button/ButtonLabel';
import { useControllerFlowStepsContext } from '../../../hooks/ControllerFlowStepsContext';
import StepHeader from '../../../components/Wizard/StepHeader';

export default function Success() {
  const navigate = useNavigate();

  const { setControllerViews, getOrigin } = useControllerFlowStepsContext();

  const url = `${
    !getOrigin()
      ? '/recuperar-senha/sucesso'
      : '/' + getOrigin() + '/recuperar-senha/sucesso'
  }`;

  useEffect(() => {
    navigate(url);
  }, [navigate]);

  function redirect() {
    setControllerViews({});
    navigate(!getOrigin() ? '/signin' : `/${getOrigin()}/signin`);
  }

  return (
    <div className="card__section">
      <div className="card__top">
        <StepHeader
          title="Ufa"
          description={[
            'Essa foi por pouco! Conseguimos recuperar sua senha e vamos te levar para sua Conta SBT.',
            'Lembre-se de adicionar uma camada extra de segurança usando o “Continuar com Google” no seu painel de segurança da Conta SBT.'
          ]}
        />
      </div>

      <div className="button-group">
        <Button full onClick={redirect}>
          <ButtonLabel>entrar</ButtonLabel>
        </Button>
      </div>
    </div>
  );
}
